import { render, staticRenderFns } from "./workflowSettingManageList.vue?vue&type=template&id=35cbfdc4&scoped=true"
import script from "./workflowSettingManageList.vue?vue&type=script&lang=js"
export * from "./workflowSettingManageList.vue?vue&type=script&lang=js"
import style0 from "./workflowSettingManageList.vue?vue&type=style&index=0&id=35cbfdc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbfdc4",
  null
  
)

export default component.exports